module.exports = __webpack_public_path__ + "images/aloha50__glyph@2x-0d5c5d0ff7871ee31c58bda8c028053f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/aloha50__glyph@2x.png
// module id = ./src/images/logo/aloha50__glyph@2x.png
// module chunks = 1